"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'template-a[desktop]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 100,
      'letterSpacing': 0,
      'lineHeightPx': 100,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -451,
        'y': 3759,
        'width': 900,
        'height': 100
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 40,
      'letterSpacing': 0,
      'lineHeightPx': 48,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -451,
        'y': 3847,
        'width': 900,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -451,
        'y': 3910,
        'width': 900,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -405,
        'y': 4407,
        'width': 249,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -405,
        'y': 4458,
        'width': 249,
        'height': 105
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'Image': {
      'fontFamily': '',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': '',
      'absoluteBoundingBox': {
        'x': -405,
        'y': 4003,
        'width': 249,
        'height': 374
      },
      'children': []
    }
  },
  'template-a[tablet]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 899,
        'y': 3759,
        'width': 708,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 899,
        'y': 3837,
        'width': 708,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 894,
        'y': 3892,
        'width': 713,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 18,
      'letterSpacing': 0,
      'lineHeightPx': 27,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 899,
        'y': 4503,
        'width': 309,
        'height': 27
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 899,
        'y': 4545,
        'width': 309,
        'height': 84
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'Image': {
      'fontFamily': '',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': '',
      'absoluteBoundingBox': {
        'x': 899,
        'y': 4009,
        'width': 309,
        'height': 464
      },
      'children': []
    }
  },
  'template-a[mobile]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1933,
        'y': 3729,
        'width': 327,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1933,
        'y': 3807,
        'width': 327,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1933,
        'y': 3862,
        'width': 327,
        'height': 120
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 18,
      'letterSpacing': 0,
      'lineHeightPx': 27,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1933,
        'y': 4449,
        'width': 271,
        'height': 27
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1933,
        'y': 4491,
        'width': 271,
        'height': 105
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'Image': {
      'fontFamily': '',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': '',
      'absoluteBoundingBox': {
        'x': 1933,
        'y': 4012,
        'width': 271,
        'height': 407
      },
      'children': []
    }
  },
  'template-b[desktop]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 100,
      'letterSpacing': 0,
      'lineHeightPx': 100,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -451,
        'y': 5259,
        'width': 900,
        'height': 100
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 40,
      'letterSpacing': 0,
      'lineHeightPx': 48,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -451,
        'y': 5347,
        'width': 900,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -451,
        'y': 5410,
        'width': 900,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 18,
      'letterSpacing': 0,
      'lineHeightPx': 27,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -544,
        'y': 5907,
        'width': 249,
        'height': 27
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -544,
        'y': 5949,
        'width': 249,
        'height': 105
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'Image': {
      'fontFamily': '',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': '',
      'absoluteBoundingBox': {
        'x': -544,
        'y': 5503,
        'width': 249,
        'height': 374
      },
      'children': []
    }
  },
  'template-b[tablet]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 899,
        'y': 5259,
        'width': 708,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 899,
        'y': 5337,
        'width': 708,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 899,
        'y': 5392,
        'width': 708,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1176,
        'y': 5615,
        'width': 431,
        'height': 21
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1176,
        'y': 5651,
        'width': 431,
        'height': 63
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'Image': {
      'fontFamily': '',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': '',
      'absoluteBoundingBox': {
        'x': 899,
        'y': 5509,
        'width': 247,
        'height': 368
      },
      'children': []
    }
  },
  'template-b[mobile]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1933,
        'y': 5229,
        'width': 327,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1933,
        'y': 5307,
        'width': 327,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1933,
        'y': 5362,
        'width': 327,
        'height': 120
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1933,
        'y': 6033,
        'width': 327,
        'height': 21
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'headline2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1933,
        'y': 6069,
        'width': 327,
        'height': 84
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'Image': {
      'fontFamily': '',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': '',
      'absoluteBoundingBox': {
        'x': 1933,
        'y': 5512,
        'width': 327,
        'height': 491
      },
      'children': []
    }
  }
};
exports.default = _default;